import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckBranchParameters } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_PARAMETERS } from '@constants/queryKeys';

const useQueryConsistencyCheckParameters = (comparisonId: string) => {
	const {
		data: parametersOptions,
		isLoading: isLoadingParametersOptions,
		isFetching: isFetchingParametersOptions,
	} = useQuery<string[], TSelectOption[]>({
		queryKey: [CONSISTENCY_PARAMETERS, comparisonId],
		queryFn: extractQueryParams(getConsistencyCheckBranchParameters),
		select: (options) => fieldsOptionsFormatted(options || []),
		enabled: [comparisonId],
		...refetchOptions,
	});

	return {
		parametersOptions: parametersOptions || [],
		isLoadingParametersOptions: (isLoadingParametersOptions && !!parametersOptions)
			|| isFetchingParametersOptions,
	};
};

export default useQueryConsistencyCheckParameters;
